module.exports = __webpack_public_path__ + "img/fushimi-HP-nyuka-image001.145e2279.jpg";